import { layoutStyle } from '@/utils/constants';

export default {
  namespaced: true,
  state: {
    layoutStyle: 1,
    materialSwitch: 'chat',
    layoutColor: 'light',
    isVideoFullScreen: false,
    isMaterialFullScreen: false,
    isMobileSize: false,
    isRemoteFitted: false,
    isLocalFitted: false,
    isVideoReloading: false,
    sliderLayout: null,
    sliderPdfWidth: null,
    isIpadDevice: false,
    videoOverlayActivated: false,
    isMenuVisible: null,
    isVocabularyVisible: false,
    isVocabularyDeleteVisible: false,
    sliderPdfHtmlWidth: null,
  },
  getters: {
    /**
     * Check if current layout is video/screen streaming
     *
     * @return boolean
     */
    isVideoScreenLayout: state => {
      return state.layoutStyle === layoutStyle.videoScreen
    },

    /**
     * Check if current layout is default
     *
     * @return boolean
     */
    isDefaultLayout: state => {
      return state.layoutStyle === layoutStyle.default
    },

    /**
     * Check if current layout is material display
     *
     * @return boolean
     */
    isMaterialLayout: state => {
      return state.layoutStyle === layoutStyle.material
    },

    /**
     * Check if slider layout is using material display
     *
     * @return boolean
     */
    isSliderInLayout2: state => {
      return state.sliderLayout === layoutStyle.material
    },

    /**
     * Check if current Color is toggled
     *
     * @return boolean
     */    
    isColorSchemeDark: state => {
      return state.layoutColor === 'dark';
    }
  },
  mutations: {
    setLayoutStyle(state, payload) {
      state.layoutStyle = payload;
    },
    setSliderLayout(state, payload) {
      state.sliderLayout = payload;
    },
    setMaterialState(state, data) {
      state.materialSwitch = data;
      state.isVideoFullScreen = false;
      state.isMaterialFullScreen = false;
    },
    videoFullScreen(state) {
      state.isVideoFullScreen = !state.isVideoFullScreen;
    },
    materialFullScreen(state) {
      state.isMaterialFullScreen = !state.isMaterialFullScreen;
    },
    setLayoutColor(state, payload) {
      state.layoutColor = payload;
    },
    setIsMobileSize(state, payload) {
      state.isMobileSize = payload;
    },
    setIsRemoteFitted(state, payload) {
      state.isRemoteFitted = payload;
    },
    setIsLocalFitted(state, payload) {
      state.isLocalFitted = payload;
    },
    setIsVideoReloading(state, payload) {
      state.isVideoReloading = payload;
    },
    setSliderPdfWidth(state, payload) {
      state.sliderPdfWidth = payload;
    },
    setSliderPdfHtmlWidth(state, payload) {
      state.sliderPdfHtmlWidth = payload;
    },
    setIsIpadDevice(state, payload) {
      state.isIpadDevice = payload;
    },
    setVideoOverlayActivated(state, payload) {
      state.videoOverlayActivated = payload;
    },
    setIsMenuVisible(state, payload) {
      state.isMenuVisible = payload;
    },
    setIsVocabularyVisible(state, payload) {
      state.isVocabularyVisible = payload;
    },
    setIsVocabularyDeleteVisible(state, payload) {
      state.isVocabularyDeleteVisible = payload;
    }
  },
  actions: {
    /**
     * Switch Layout
     *
     * @param {commit} commit
     * @return void
     */
    switchLayoutStyle({ commit }, layout) {
      commit('setLayoutStyle', layout);
    },

    /**
     * Switch Slider Layout Between Layout 1 and 2
     *
     * @param {commit} commit
     * @return void
     */
    switchSliderLayout({ commit, state }, layout) {
      if (layout !== state.sliderLayout) {
        commit('setSliderLayout', layout);
      }
    },

    /**
     * Switch Material State
     *
     * @param {commit} commit
     * @return void
     */
    switchMaterialState({ commit }, layout) {
      commit('setMaterialState', layout);
    }, 

    /**
     * Switch Layout Color
     *
     * @param {commit} commit
     * @return void
     */
    switchLayoutColor({ commit }, layout) {
      commit('setLayoutColor', layout);
    },

    /**
     * Check if screen size is for mobile/pc design
     *
     * @param {commit} commit
     * @return void
     */
    checkMediaSize({ commit }) {
      let isMediaSetBreakPoint = window.innerWidth < 960;
      commit('setIsMobileSize', isMediaSetBreakPoint);
    },

    /**
     * Check the device if it's an iPad
     *
     * @param {commit} commit
     * @return void
     */
    checkIfIpadDevice({ commit }) {
      // using ua-parser library detects iPad with version 13+ identical with MacOS computer
      const isIpad = !!(navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      const isOldIpad = (/iPad/.test(navigator.platform) && navigator.maxTouchPoints > 2);
      commit('setIsIpadDevice', isIpad || isOldIpad);
    }
  }
};
